<div class="d-flex input-group input-group-sm d-grid gap-2 pe-2">

  <input [(ngModel)]="searchablePropertyName" class="form-control form-control-sm"
    [ngClass]="{'is-invalid': !inputIsValid}" placeholder="Type to search..." (focus)='propertyListVisible = true'
    (blur)='hideSearchablePropertyList()'>
    @if (propertyListVisible) {
      <div class='mt-4 border rounded'
        style='position: fixed; z-index: 10500; max-height: 400px; overflow: auto;' (mousedown)="preventBlur($event)">
        @for (property of searchableProperties | searchSortByName: searchablePropertyName; track property) {
          <div class="bg-dark dropdownItems"
            >
            <div class="p-2 dropdownSubItems" (mousedown)='selectSearchableProperty(property)'>
              <span>{{property.name}}</span>
            </div>
          </div>
        }
      </div>
    }

    <select class='form-control form-control-sm form-select' [(ngModel)]="rule.operator"
      (change)="onRuleTypeChange($event.target.value)">
      @for (operator of operators; track operator) {
        <option [value]="operator">{{ operator | titlecase }}</option>
      }
    </select>

    @if (userInputType == 'boolean') {
      <input type="checkbox" class="btn-check" id="btn-check" autocomplete="off" [checked]="rule.userInput"
        (change)="onBooleanUserInputChange()">
        <label class="btn btn-primary" for="btn-check">
          {{ rule.userInput === 'true' ? 'True' : 'False'}}
        </label>
      }

      @if (userInputType == 'number' || userInputType == 'text') {
        <input type="text"
          class="form-control form-control-sm form-input" [(ngModel)]="rule.userInput"
          (change)="onUserInputChange($event.target.value)">
      }
    </div>